import { useRouteError } from 'react-router'
import { Button } from '@/shared/components/ui/button'

const CHUNK_ERROR_PATTERNS = [
  'Failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'Importing a module script failed',
  'Loading chunk',
  'ChunkLoadError',
]

function isChunkError(error: unknown): boolean {
  if (error instanceof Error) {
    return CHUNK_ERROR_PATTERNS.some((pattern) => error.message.includes(pattern))
  }
  return false
}

export default function RouteErrorBoundary() {
  const error = useRouteError()
  const chunkError = isChunkError(error)

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-6">
      {chunkError ? (
        <div className="flex flex-col items-center gap-4 text-center">
          <h2 className="text-xl font-semibold">App Updated</h2>
          <p>A new version is available. Please reload the app.</p>
          <Button variant="default" onClick={() => window.location.reload()}>
            Reload
          </Button>
        </div>
      ) : (
        <div className="flex flex-col items-center gap-4 text-center">
          <h2 className="text-xl font-semibold">Something went wrong</h2>
          <p>Please try again.</p>
        </div>
      )}
    </div>
  )
}
